/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCircleLetterP = createReactComponent("circle-letter-p", "IconCircleLetterP", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M10 12h2a2 2 0 1 0 0 -4h-2v8", key: "svg-1" }]
]);

export { IconCircleLetterP as default };
//# sourceMappingURL=IconCircleLetterP.js.map
